<template>
    <div class="p-10">
        <div class="mb-7">
            <div class="capitalize text-3xl text-gray-400 font-Inter font-semibold mb-5">
                contact
            </div>
            <div class="text-sm text-gray-400 font-Inter font-semibold">
                Aliquam finibus risus sit amet faucibus tincidunt. Praesent in nisl nisl. Pellentesque dui diam, congue
                in tincidunt sed, lobortis quis tellus.
            </div>
        </div>

        <v-form v-model="valid">
            <v-container class="pa-0 contact_form">
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="firstname" :rules="nameRules" :counter="10" dark solo
                            background-color="#363636" class="!rounded-2xl " label="Your Full Name"
                            required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="email" :rules="emailRules" dark solo background-color="#363636"
                            class="!rounded-2xl " label="Your Email Address" required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="number" dark solo background-color="#363636" class="!rounded-2xl "
                            label="Your Contact Number" required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="lastname" :rules="nameRules" :counter="10" dark solo
                            background-color="#363636" class="!rounded-2xl " label="Country/State"
                            required></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea background-color="#363636" class="!rounded-2xl" solo name="input-7-4"
                            label="Your Message Here"></v-textarea>
                    </v-col>
                </v-row>
            </v-container>

        </v-form>
        <v-btn type="submit" rounded :loading="loading" dark :class="`${routeLink}_color`"
            class="mb-5 py-3 px-5 !text-black !text-sm">Update</v-btn>



    </div>
</template>

<script>
export default {
    data: () => ({
        valid: false,
        firstname: '',
        loading : false,
        number: '',
        nameRules: [
            v => !!v || 'Name is required',
            v => v.length <= 10 || 'Name must be less than 10 characters',
        ],
        email: '',
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+/.test(v) || 'E-mail must be valid',
        ],
    }),
    computed: {
        colorAsRoute() {
            if (this.routeLink == 'straight') {
                return '#a07a1d'
            }
            else if (this.routeLink == 'gay') {
                return '#88c3fa'
            }
            else if (this.routeLink == 'lesbian') {
                return '#9e2eec'
            }
        }
    },
}
</script>
<style scoped>
.contact_form:deep(input) {
    font-size: 14px !important;
    color: #838383 !important;
    padding: 0 10px !important;
}
.contact_form:deep(textarea) {
    font-size: 14px !important;
    color: #838383 !important;
    padding: 0 10px !important;
}

.contact_form:deep(.v-label) {
    font-size: 14px !important;
    color: #838383 !important;
    padding: 0 10px !important;

}
.straight_color {
    /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
    background: rgb(177, 145, 65);
    background: linear-gradient(345deg,
        rgb(97 69 0) 0%,
        rgba(202, 174, 112, 1) 53%,
        rgb(90 64 0 / 97%) 100%);
  }
  .lesbian_color {
    background: rgb(126, 0, 157);
    background: linear-gradient(208deg,
        rgba(126, 0, 157, 0.9416141456582633) 2%,
        rgba(161, 51, 246, 1) 45%,
        rgba(157, 0, 176, 0.9668242296918768) 96%);
  }
  
  .gay_color {
    background: rgb(0, 240, 255);
    background: linear-gradient(39deg,
        rgba(0, 240, 255, 1) 0%,
        rgba(0, 156, 255, 1) 100%);
  }
  
</style>